module.exports = __webpack_public_path__ + "static/Merriweather-Bold-9ccb885c9cf8e503d557f15e0b2cbf24.ttf";